import script from "./Mypage.vue?vue&type=script&setup=true&lang=js"
export * from "./Mypage.vue?vue&type=script&setup=true&lang=js"

import "./Mypage.vue?vue&type=style&index=0&id=7a26860b&lang=scss"

const __exports__ = script;

export default __exports__